module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./~/styled-jsx/style.js
// module id = 15
// module chunks = 114276838955818 118588435947235 218655834487403